import {
    BridgePosition,
    ChatEntry, GameSelector,
} from '../app/types';
import { Button } from './tableSlice';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
export type OutputButton = Pick<Button, 'id' | 'value'>;

export type OutputState = {
    changePlay?: 'startPlay' | 'stopPlay' | 'replay';
    chatEntry?: ChatEntry;
    claim?: number;
    closeResults?: true;
    conventionCardUrl?: string;
    director?: string;
    gameSelector?: GameSelector;
    invite?: {
        email: string;
        bridgePosition: BridgePosition;
    };
    prevNext?: 'prev' | 'next';
    undo?: true;
};

export const initialState: OutputState = {};

export const outputSlice = createSlice({
    name: 'output',
    initialState,
    reducers: {
        output_sendConventionCardUrl: (state, { payload }: PayloadAction<OutputState['conventionCardUrl']>) => {
            state.conventionCardUrl = payload;
        },
        output_setChangePlay: (state, { payload }: PayloadAction<OutputState['changePlay']>) => {
            state.changePlay = payload;
        },
        output_setChatEntry: (state, { payload }: PayloadAction<OutputState['chatEntry']>) => {
            state.chatEntry = payload;
        },
        output_setCloseResults: (state, { payload }: PayloadAction<OutputState['closeResults']>) => {
            state.closeResults = payload;
        },
        output_setDirector: (state, { payload }: PayloadAction<OutputState['director']>) => {
            state.director = payload;
        },
        output_setGameSelector: (state, { payload }: PayloadAction<OutputState['gameSelector']>) => {
            state.gameSelector = payload;
        },
        output_setInvite: (state, { payload }: PayloadAction<OutputState['invite']>) => {
            state.invite = payload;
        },
        output_setMakeClaim: (state, { payload }: PayloadAction<number>) => {
            state.claim = payload;
        },
        output_setPrevNext: (state, { payload }: PayloadAction<OutputState['prevNext']>) => {
            state.prevNext = payload;
        },
        output_setRequestUndo: (state, { payload }: PayloadAction<OutputState['undo']>) => {
            state.undo = payload;
        },
        // resets
        output_reset: () => initialState,
    },
});

export const outputActions = outputSlice.actions;

// TODO: add some selectors
// export const selectHighlighted = (state: RootState) => state.card.highlighted;
// export const selectRaised = (state: RootState) => state.card.raised;
// export const selectRank = (state: RootState) => state.card.rank;
// export const selectSuit = (state: RootState) => state.card.suit;
// export const selectSuitSymbol = (state: RootState) => state.card.suitSymbol;
// export const selectVisible = (state: RootState) => state.card.visible;

export default outputSlice.reducer;
